import { SHA256 } from 'crypto-js'
import Cookies from 'js-cookie'
import { post } from "./api"

export async function signUp(user) {
  try {
    const userWithHashedPassword = {
      ...user,
      password: await _sha256HashPassword(user.password)
    }
    const response = await post('signup', userWithHashedPassword)
    if (response.status === 200) {
      setAuthCookies(response?.data)
    }
    return response
  } catch (error) {
    return { error }
  }
}

export async function login(email, password) {
  try {
    const parameters = {
      email,
      password: await _sha256HashPassword(password)
    }
    const response = await post('login', parameters)
    if (response.status === 200) {
      setAuthCookies(response?.data)
    }
    return response
  } catch (error) {
    return { error }
  }
}

export async function logout() {
  try {
    clearAuthCookies()
  } catch (error) {
    return { error }
  }
}

export async function changePassword(oldPassword, newPassword) {
  try {
    const parameters = {
      oldPassword: await _sha256HashPassword(oldPassword),
      newPassword: await _sha256HashPassword(newPassword)
    }
    const response = await post('changePassword', parameters)
    if (response.status === 200) {
      setAuthCookies(response?.data)
    }
    return response
  } catch (error) {
    return { error }
  }
}

export function isLoggedIn() {
  return Cookies.get('token')
}

function setAuthCookies(user) {
  Cookies.set('firstName', user?.firstName)
  Cookies.set('lastName', user?.lastName)
  Cookies.set('userId', user?.id)
  Cookies.set('userType', user?.userType)
  Cookies.set('token', user?.token)
  Cookies.set('email', user?.email)
}

function clearAuthCookies(user) {
  Cookies.remove('firstName')
  Cookies.remove('lastName')
  Cookies.remove('userId')
  Cookies.remove('userType')
  Cookies.remove('token')
  Cookies.remove('email')
}

async function _sha256HashPassword (password ) {
  try {
    // Hash the password using the generated salt
    const hash = await SHA256(password).toString()

    // You can save the 'hash' in your database for future authentication checks
    return hash
  } catch (error) {
    console.error('Error hashing password:', error)
    throw error // Rethrow the error to be handled elsewhere in your application
  }
}
